/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Invite_DoneInputs */

const cs_settings_users_invite_done = /** @type {(inputs: Settings_Users_Invite_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotovo`)
};

const en_settings_users_invite_done = /** @type {(inputs: Settings_Users_Invite_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Settings_Users_Invite_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_invite_done = /** @type {((inputs?: Settings_Users_Invite_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Invite_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_invite_done(inputs)
	return cs_settings_users_invite_done(inputs)
});